module.exports = __webpack_public_path__ + "static/media/38.b8424060.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/38.jpg
// module id = 728
// module chunks = 0